import { useEffect } from "react";
import io from "socket.io-client";
import { Outlet } from "react-router-dom";

import { CurrentUser, queryClient } from "../../App";

import { LenderTicket } from "@Types/tickets";
import useCheckVersion from "@Hooks/useCheckVersion";
import UpdateBanner from "@Components/UpdateBanner/UpdateBanner";

type Payload = {
  action: "create" | "update";
  entity: "lender_ticket";
  entry: LenderTicket;
};

const getSocket = (currentUser: CurrentUser) => {
  return currentUser?.getIdToken().then(async (token) => {
    const socket = io(process.env.REACT_APP_SOCKET_URL + "/lender", {
      auth: {
        token,
        firebaseName: process.env.REACT_APP_FIREBASE_PROJECT_ID,
      },
      query: { connectedAt: new Date().getTime() },
    });
    socket.on("connect", () => {
      console.log("Connected!");
    });
    socket.on("new_version", (payload: { app: string; version: string; force: boolean }) => {
      if (payload.app !== "lender") return;
      queryClient.setQueryData(["app-version"], { version: payload.version, force: payload.force });
    });
    socket.on(`${currentUser?.email}_live_updates`, (payload: Payload) => {
      switch (payload.action) {
        case "create":
          switch (payload.entity) {
            default:
              break;
          }
          break;
        case "update":
          switch (payload.entity) {
            case "lender_ticket": {
              const entry = payload.entry as LenderTicket;
              queryClient.setQueriesData<LenderTicket>(
                [`ticket-${entry._id}`],
                () => entry,
              );
              queryClient.setQueriesData<LenderTicket[]>(
                ["tickets"],
                (oldData) => {
                  return (oldData ?? [])?.map((oldTicket) =>
                    oldTicket._id === entry._id ? entry : oldTicket,
                  );
                },
              );
              break;
            }
            default:
              break;
          }
          break;

        default:
          break;
      }
    });
    return socket;
  });
};

const SocketConnection = ({ currentUser }: { currentUser: CurrentUser }) => {
  const { hasUpdate, force } = useCheckVersion();

  useEffect(() => {
    const socket = getSocket(currentUser);

    return () => {
      socket?.then((resolvedSocket) => resolvedSocket.close());
    };
  }, [currentUser]);
  return (
    <>
      <Outlet />
      {hasUpdate && <UpdateBanner force={force} />}
    </>
  );
};

export default SocketConnection;
